import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [];

  openDocumentModal() {
    const element = $('#facility-new-document-modal');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.attr('src', element.data('targetUrl'));
    element.modal({ show: true, backdrop: 'static', keyboard: false });
  }

  closeDocumentModal() {
    const element = $('#facility-new-document-modal');
    element.modal('hide');
    const frameId = element.data('frameId');
    const frame = element.find(`#${frameId}`);
    frame.src = '';
  }
}
